export default function Cta() {
  return (
    <>
      <section className="cta">
        <div className="cta-court" aria-hidden="true"></div>
        <div className="cta-glow" aria-hidden="true"></div>
        <div className="cta-inner">
          <p className="eyebrow">Ready to change the way your club runs?</p>
          <h2 className="h-xl" style={{ marginTop: '20px', fontSize: 'clamp(34px, 5.4vw, 76px)', lineHeight: '.98' }}>Let&rsquo;s Get Your Club<br />in the Game.</h2>
          <p className="lead" style={{ margin: '24px auto 0', maxWidth: '620px' }}>
            See how PlaySlot can simplify operations, increase utilization and create a better experience for your players.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '36px' }}>
            <a className="btn btn-primary" href="#demo">Request a Demo</a>
          </div>
        </div>
      </section>
    </>
  );
}
